module.exports = __webpack_public_path__ + "static/media/mercedes_05.027ee3b1.png";